import Model from 'models/Model';
import { CreateMethod } from 'models/Order';

import { changeFromCent } from 'utils/math';

import { OrderPaymentData } from './PaymentTransaction';

enum ItemType {
    Product = 'Product',
    Package = 'Package',
    Voucher = 'Voucher',
}

interface DataByProductType {
    id: string;
    name: string;
    quantity: number;
    gender: string;
    category: string;
    price: number;
    itemType: string;
}

interface AdditionalGtmOrderData {
    affiliation: string;
    paymentProvider: string;
    createMethod: CreateMethod;
}

export default class GtmPaymentOrder implements Model {
    id: string;
    currencyCode: string;
    orderItems: any;
    finalPrice: number;
    discountCode?: string;
    affiliation: string;
    paymentProvider: string;
    buyNow: boolean;

    constructor(data: OrderPaymentData, additionalGtmOrderData: AdditionalGtmOrderData) {
        this.id = data?.order?.cartId || data.id;
        this.currencyCode = data.currency.code;
        this.orderItems = data.order.items;
        this.finalPrice = changeFromCent(data.order.price);
        this.discountCode = data?.order?.discountCode?.code || null;
        this.affiliation = additionalGtmOrderData.affiliation || '';
        this.paymentProvider = additionalGtmOrderData.paymentProvider || '';
        this.buyNow = additionalGtmOrderData.createMethod === CreateMethod.BuyNow;
    }

    parseGtmItems = (): DataByProductType => {
        return this.orderItems.map((item) => {
            let itemType;

            if (item.productType.includes(ItemType.Voucher)) itemType = ItemType.Voucher;
            if (item.productType.includes(ItemType.Package)) itemType = ItemType.Package;
            if (item.productType.includes(ItemType.Product)) itemType = ItemType.Product;

            return {
                id: item.productId,
                name: item.productName,
                quantity: item.quantity,
                price: changeFromCent(item.price).toFixed(2),
                gender: item?.product?.gender || '',
                category: item?.product?.category || '',
                itemType,
                dimension3: item.location?.name || null,
                dimension4: item.pricing?.promoPercent || null,
            };
        });
    };
};
